import { Box, Text } from '@wix/design-system';
import { useCredit } from '@wix/package-picker-shared-studio';
import React from 'react';
import { StudioPackagePickerModule } from '../../../modules/studio-package-picker.module';
import s from '../Header.scss';

export const UpgradePromotionalMessage = () => {
  const { Trans } = StudioPackagePickerModule.internals.useTranslations();
  const credit = useCredit();

  return (
    <Box align="center" width="100%">
      {credit.isLowCredit ? (
        <Text className={s.withDash}>
          <Trans i18nKey="app.second_upgrade_text" />
        </Text>
      ) : (
        <Text className={s.withDash}>
          <Trans
            i18nKey="app.second_upgrade_optimization.subtitle"
            values={{
              credit: credit.formattedValue,
              currentPlan: credit.currentPlan,
            }}
            components={{
              creditPart: <Text skin="success" weight="bold" />,
            }}
          />
        </Text>
      )}
    </Box>
  );
};
